export default "__VITE_ASSET__Z$7jWT6c__"